<app-paginated-table [paginationResponseResolver]="paginationResponseResolver()"
  [defaultPaginationParameters]="defaultPaginationParameters()" [supportedActions]="supportedActions()"
  [tableConfig]="finalTableConfig()" (actionExecuted)="onActionExecuted($event)" [showFilterBtn]="showFilterBtn()"
  [filterOptions]="filterOptions()" (applyFilter)="onApplyFilter($event)" (clearFilter)="onClearFilter()" />

<ng-template #tableRowTemplate let-element>
  <td>#{{ element.autoIncrementalId }}</td>
  <ng-container *ngIf="tableConfig()?.template; else defaultTemplate">
    <ng-container *ngTemplateOutlet="tableConfig()!.template; context: { $implicit: element }"></ng-container>
  </ng-container>
  <ng-template #defaultTemplate let-element></ng-template>
  <td>
    {{ element.createdOnUtc | dateFormat }}
  </td>
</ng-template>
